"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regist_1 = require("../../../redux/regist");
const actionTypes_1 = require("./actionTypes");
const initialState = {
    classes: undefined,
};
regist_1.ReducerRegistry.register('base/classes', (state = initialState, action) => {
    switch (action.type) {
        case actionTypes_1.SET_CLASSES_DATA:
            return {
                ...state,
                classes: action.classes,
            };
    }
    return state;
});
